@if(initialized && termsOfUse) {

<span class="info-page-text" [innerHTML]="termsOfUse"></span>

}
